import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
  Button,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import grey from "@material-ui/core/colors/grey";
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import clsx from "clsx";
import shiObj from './shipformerObj';
import MenuItem from '@material-ui/core/MenuItem';
import { getDefaultTabName } from "../../services/FunctionServices";
import FilterComponents from "../FilterComponents/FilterComponents";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import { getCookie } from "../../services/Cookies";
import { getRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    // textAlign: "center",
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
    textTransform: "capitalize",
  },
  alignment: {
    alignItems: "center",
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "200px",
    "& select": {
      padding: "6px"
    }
  }
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }

  },
}))(InputBase);

export default function ShipForm(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [filter, setFilter] = React.useState(true);
  const [formObj, setFormObj] = useState(shiObj);
  const [open, setOpen] = React.useState(false);
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
  const { customerData, equipmentData, typeOfShipData, fetchFitterObject, clearFilter } = props;
  const [defaultTabName] = getDefaultTabName();
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  const defaultValue = (val) => {
    //
    if (val !== "" && val !== undefined && val !== "null") {
      let Obj = JSON.parse(val);
      setfiltercomObj(Obj);
      console.log('getcookievalue', formObj)
    }
  }
  useEffect(() => {
    defaultValue(GlobalFilterSettingValue);

  }, [])

  const applyFilter = (obj) => {
    //console.log(formObj);

    //fetchFitterObject(formObj)
    fetchFitterObject(obj);
  }
  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
    // //console.log(formObj);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const onClear = () => {

    setFormObj(shiObj)
    clearFilter()
  };
  const enterKey = (event) => {
    if (event.key === 'Enter') {
      applyFilter()
    } if (event.key === 'Escape') {
      onClear()
    }
  }
  const customernameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, customerNameKey: newValue })
  }
  const shipnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, shipNameImokey: newValue })
  }
  const LubeEquipnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipname: newValue })
  }
  const LubeMakenameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipmake: newValue })
  }
  const LubeModelnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipmodel: newValue })
  }
  return (
    <div>
      <Box className="decarbox1" component="div" style={{padding: "20px"}}  >
      <FilterComponents filtervalue={["CustomerName","ShipName_imo","EquipMake","EquipModel","EquipName"]} applyFilter={applyFilter} reset={onClear} />
      </Box>
      {/* <Box component="div" px={1} py={1} display={filter ? "block" : "none"}>
        <Box
          component="div"
          display="flex"
          pb={1}
          className={clsx(
            classes.justifyContentBetween,
            classes.alignItemsStretch
          )}

        >
          <Grid container spacing={3}>
            <Grid className="ast-grid ship-filter" item xs={12} sm={6} md={3}>
              <Box
                component="div" style={{ width: "100%" }}
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
                onKeyDown={enterKey}
              >
                <Box
                  component="div"
                  display="flex"
                  className={classes.justifyContentBetween}
                  alignItems="flex-end"
                  height={1}
                >
                  <Box className="filter-col" component="div" width={1} display="block">
                    <Box
                      component="div"
                      display="flex"
                      className="filter-col-in"
                      alignItems="end"
                      pb={1}

                    >
                      <FilterComponents filtervalue={["CustomerName"]} customerChange={customernameparent} />
                     
                    </Box>
                    <Box
                      component="div"
                      display="flex"
                      className="filter-col-in"
                      alignItems="end"
                      pb={1}
                    >
                      <FilterComponents filtervalue={["ShipName_imo"]} shipChange={shipnameparent} />
                     
                    </Box>

                    <Box
                      component="div"
                      display="flex"
                      className="filter-col-in"
                    >
                     
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid ship-filter" item xs={12} sm={6} md={3} >
              <Box
                component="div" style={{ width: "100%" }}
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
                onKeyDown={enterKey}
              >
                {defaultTabName == "Lube" ? (
                  <Box
                    component="div"
                    display="flex"
                    className="filter-col-in"
                    pb={1}
                  >
                    <FilterComponents filtervalue={["EquipMake"]}  LubeMakenameChange={LubeMakenameparent}/>
                  </Box>
                ) : ""}
                {defaultTabName == "Lube" ? (
                  <Box
                    component="div"
                    display="flex"
                    className="filter-col-in"
                    pb={1}
                  >

                    <FilterComponents filtervalue={["EquipModel"]} LubeModelnameChange={LubeModelnameparent}/>
                  </Box>
                ) : ""}
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"

                >
                 
                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid ship-filter" item xs={12} sm={6} md={3}>
              <Box
                component="div" style={{ width: "100%" }}
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
                onKeyDown={enterKey}
              >
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                  pb={1}
                >
                  <FilterComponents filtervalue={["EquipName"]} LubeEquipnameChange={LubeEquipnameparent}/>
                
                </Box>
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                >
                
                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid ship-filter" item xs={12} sm={6} md={3} >
              <Box
                component="div" style={{ width: "100%" }}
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
                onKeyDown={enterKey}
              >
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                  pb={1}
                >
                  <FilterComponents filtervalue={["TypeofShip"]} />

                
                </Box>
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                >
                
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box component="div" display="flex" py={1} pl={1} justifyContent="left"   >
          <Button variant="outlined" onClick={applyFilter} className={classes.btnStyle2}>
            Apply Filters
          </Button>
          <Button variant="outlined" onClick={onClear} className={classes.btnStyle2}>
            Reset
          </Button>
        </Box>
      </Box> */}
    </div>
  );
}
